import { HEART_W, HEART_H, MAX_LIVES, MAX_HEART_SLOTS, GAME_W, GAME_H, PROGRESS_BAR_W, PROGRESS_BAR_H } from "./data";
import { gameState } from "./state";
import { level } from "./terrain";
import { getImage } from "./images";
import { Asset } from "assets.gen";

export const hud = {
  _hearts: [] as number[],
  visible: true,

  reset(): void {
    this.visible = !gameState.emulation;
    this._hearts = [];
    for (let i = 0; i < MAX_LIVES; i++) this._hearts.push(1);
  },

  changeHearts(delta: number): void {
    if (delta < 0) {
      for (let i = this._hearts.length - 1; i >= 0; i--) {
        if (this._hearts[i] === 1) {
          this._hearts[i] = 0;
          break;
        }
      }
    }
  },

  addHeartSlot(): void {
    if (this._hearts.length < MAX_HEART_SLOTS) {
      this._hearts.push(0);
    }
  },

  healOneHeart(): void {
    for (let i = 0; i < this._hearts.length; i++) {
      if (this._hearts[i] === 0) {
        this._hearts[i] = 1;
        return;
      }
    }
  },

  render(ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D): void {
    if (!this.visible) return;

    const heartImg = getImage(Asset.gfx_heart);

    ctx.font = '8px "grixel"';
    ctx.fillStyle = "#ffffff";
    ctx.textBaseline = "bottom";
    const scoreText = gameState.score.toString();
    ctx.fillText(scoreText, 2, GAME_H - 2);

    if (heartImg) {
      const visibleSlots = Math.min(this._hearts.length, MAX_HEART_SLOTS);
      for (let i = 0; i < visibleSlots; i++) {
        const x = GAME_W - 10 - (visibleSlots - 1 - i) * 9;
        const y = GAME_H - HEART_H - 12;
        const value = this._hearts[i];

        if (value === 1) {
          ctx.globalAlpha = 1;
          ctx.drawImage(heartImg, 0, 0, HEART_W, HEART_H, x, y, HEART_W, HEART_H);
        } else {
          ctx.globalAlpha = 0.5;
          ctx.drawImage(heartImg, HEART_W, 0, HEART_W, HEART_H, x, y, HEART_W, HEART_H);
        }
        ctx.globalAlpha = 1;
      }
    }

    const barX = ((GAME_W - PROGRESS_BAR_W) * 0.5) | 0;
    const barY = GAME_H - 8;
    const progress = level.zoneDistance > 0 ? Math.min(gameState.dist / level.zoneDistance, 1) : 0;
    const fillW = (PROGRESS_BAR_W * progress) | 0;

    ctx.globalAlpha = 0.4;
    ctx.fillStyle = "#555555";
    ctx.fillRect(barX, barY, PROGRESS_BAR_W, PROGRESS_BAR_H);
    ctx.globalAlpha = 0.9;
    ctx.fillStyle = "#44ff44";
    ctx.fillRect(barX, barY, fillW, PROGRESS_BAR_H);
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 1;
    ctx.strokeRect(barX - 0.5, barY - 0.5, PROGRESS_BAR_W + 1, PROGRESS_BAR_H + 1);
    ctx.globalAlpha = 1;
  },
};
